import { Action } from '@ngrx/store';
import { Guide } from '@model';

export enum GuidesActionTypes {
  GuidesLoad = '[Guides] Load guide data',
  GuidesLoadSuccess = '[Guides] Load guide success',
  GuidesLoadFail = '[Guides] Load guide fail'
}

export class GuidesLoad implements Action {
  readonly type = GuidesActionTypes.GuidesLoad;
  constructor() {}
}

export class GuidesLoadSuccess implements Action {
  readonly type = GuidesActionTypes.GuidesLoadSuccess;
  constructor(public payload: Guide[]) {}
}

export class GuidesLoadFail implements Action {
  readonly type = GuidesActionTypes.GuidesLoadFail;
  constructor(public payload: any) {}
}

export type GuidesActions = GuidesLoad | GuidesLoadSuccess | GuidesLoadFail;
